type ChevronProps = {
  disabled?: boolean;
} & React.SVGProps<SVGSVGElement>;

const ChevronLeft = (props: ChevronProps) => {
  const chevronStyles = {
    base: 'cursor-pointer user-select-none h-8 w-8 md:h-6 md:w-6',
    enabled: 'fill-primary',
    disabled: 'fill-border',
  };

  const style = props.disabled ? chevronStyles.disabled : chevronStyles.enabled;

  return (
    <svg
      {...props}
      height="1792"
      viewBox="0 0 1792 1792"
      width="1792"
      xmlns="http://www.w3.org/2000/svg"
      className={`${chevronStyles.base} ${style}`}>
      <path d="M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z" />
    </svg>
  );
};

export default ChevronLeft;
